import { computed } from 'vue';
import { useRoute } from 'vue-router';

const SUPPORTED_LOCALES = ['de', 'en', 'es', 'tr', 'uk'];

// Builds locale-prefixed paths for RouterLinks. All routes live under /:locale, so a link without
// the prefix (to="/news") only resolves via the catch-all redirect — which also breaks active-class,
// since router.resolve() matches the catch-all record instead of the real route. Prefixing with the
// current URL locale keeps navigation direct and active highlighting working.
export function useLocalePath(): (path: string) => string {
    const route = useRoute();
    const locale = computed(() => {
        const l = route.params.locale as string | undefined;
        return l && SUPPORTED_LOCALES.includes(l) ? l : 'de';
    });
    return (path: string) => `/${locale.value}/${path.replace(/^\//, '')}`;
}
